import React from 'react'
import { BANKING_BOTTOM_CONTENT, BANKING_COURSE_PAGE_4, BANKING_DETAILS_PAGE_4, BANKING_HERO_PAGE_4 } from '../../../utils/constants'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseCard from '../../../reusable/Course-card'
import Accordian from '../../../reusable/Accordian'
import { BANKING_ACCORDIAN_4 } from '../../../utils/courseConifg'
import PageDesc from '../../../reusable/PageDesc'

const BankingPage_4 = () => {
  return (
    <div className='outlet-render'>
       <CourseAsideHero  {...BANKING_HERO_PAGE_4}/>
       <CoursesAside {...BANKING_COURSE_PAGE_4}/>
       <CourseCard {...BANKING_DETAILS_PAGE_4}/>
       <Accordian {...BANKING_ACCORDIAN_4}/>
       <PageDesc {...BANKING_BOTTOM_CONTENT}/>
    </div>
  )
}

export default BankingPage_4